export default {
    label_task:{
        en:"Variety Report",
        bn:'Variety Report'
    },
    label_crop_id:{
        en:"Crop",
        bn:"Crop"
    },
    label_crop_name:{
        en:"Crop",
        bn:"Crop"
    },
    label_crop_type_id :{
        en:"Type",
        bn:"Type"
    },
    label_crop_type_name :{
        en:"Type",
        bn:"Type"
    },
    label_variety:{
        en:"Variety",
        bn:"Variety"
    },
    label_principal_id:{
        en:"Principal",
        bn:"Principal"
    },
    label_principal_name:{
        en:"Principal",
        bn:"Principal"
    },
    label_competitor_id:{
        en:"Competitor",
        bn:"Competitor"
    },
    label_competitor_name:{
        en:"Competitor",
        bn:"Competitor"
    },
}